'use client';

// import { X } from 'lucide-react';
// import { ChevronDown, X } from 'lucide-react';
// import { useTranslations } from 'next-intl';
// import { useState } from 'react';

import { Navigation } from '@/vibes/mom/primitives/navigation';
// import { Link } from '~/components/link';

// function HeaderNotification({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
//   const [closing, setClosing] = useState(false);

//   const handleClose = () => {
//     setClosing(true);
//     setTimeout(() => {
//       setClosing(false);
//       onClose();
//     }, 300);
//   };

//   return (
//     <div
//       className={`absolute left-0 top-0 z-10 flex min-h-[300px] w-full items-center bg-white shadow-lg transition-transform duration-300 ${
//         isOpen && !closing ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
//       }`}
//     >
//       <div className="container relative mx-auto flex h-full items-center p-8">
//         <button
//           aria-label="close"
//           className="absolute right-0 top-0 -ml-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-300 hover:bg-contrast-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-4"
//           name="intent"
//           onClick={handleClose}
//           type="submit"
//           value="close"
//         >
//           <X size={24} strokeWidth={2} />
//         </button>

//         <div className="grid w-full gap-4 lg:grid-cols-2 lg:gap-8">
//           <div className="flex flex-col gap-1">
//             <h2 className="font-heading-condensed text-lg uppercase leading-snug tracking-wider text-mom-gold">
//               #WhiskySanta's £1,000,000 Giveaway!
//             </h2>
//             <p>
//               Master of Malt's #WhiskySanta has returned to give away free orders, £100 vouchers,
//               tens of thousands of pressies inside packages, and to grant Christmas wishes too!
//             </p>
//             <p>
//               <Link
//                 className="flex py-2 font-heading-condensed uppercase underline hover:no-underline"
//                 href="/whisky-santa/"
//               >
//                 Read more
//               </Link>
//             </p>
//           </div>
//           <div className="flex flex-col gap-1">
//             <h2 className="font-heading-condensed text-lg uppercase leading-snug tracking-wider text-mom-gold">
//               CHRISTMAS DELIVERY IS GUARANTEED!
//             </h2>
//             <p>
//               Order online before <strong>Sunday 22nd December by 9:30pm</strong> for guaranteed
//               delivery in mainland UK.
//             </p>
//             <p>
//               You can also choose to collect from our Tonbridge office, which is open until 4pm on
//               Christmas Eve (orders must be in by 3pm).
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

interface Props {
  navigation: React.ComponentPropsWithoutRef<typeof Navigation>;
}

export const HeaderSection = ({ navigation }: Props) => {
  // const t = useTranslations('Components.Header');
  // const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      {/* <div className="flex h-[40px] w-full items-center justify-center bg-mom-black text-center text-sm font-normal leading-5 text-white">
        <span
          className="flex cursor-pointer flex-row items-center gap-1 hover:underline"
          onClick={() => setIsOpen(!isOpen)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              // Check if the user presses Enter or Space
              setIsOpen(!isOpen);
            }
          }}
          role="button"
          tabIndex={0}
        >
          {t('Banner.deliveryMessage')}
          <ChevronDown className="cursor-pointer text-white" />
        </span>
      </div> */}
      {/* <HeaderNotification isOpen={isOpen} onClose={() => setIsOpen(false)} /> */}
      <Navigation {...navigation} />
    </div>
  );
};

HeaderSection.displayName = 'HeaderSection';
